import React from 'react';

import ScheduleComponent from './ScheduleComponent';

import './schedule.scss';

const Schedule = () => (
  <div className="container abs-asset-holder schedule">
    <div id="Schedule" />
    <ScheduleComponent />
    { /* <div className="schedule__prompt">
      <p>To access full functionality of the Hack the North Live website, click the button below</p>
      <a href="https://live.hackthenorth.com/" className="button schedule__link">Go to Day-of App</a>
      </div> */ }
  </div>
);

Schedule.propTypes = {};

export default Schedule;



// WEBPACK FOOTER //
// ./src/components/Schedule/index.jsx